import {
    formatError,
    login,
    runLogoutTimer,
    saveTokenInLocalStorage,
    signUp,
} from '../../services/AuthService';


export const SIGNUP_CONFIRMED_ACTION = '[signup action] confirmed signup';
export const SIGNUP_FAILED_ACTION = '[signup action] failed signup';
export const LOGIN_CONFIRMED_ACTION = '[login action] confirmed login';
export const LOGIN_FAILED_ACTION = '[login action] failed login';
export const LOADING_TOGGLE_ACTION = '[Loading action] toggle loading';
export const LOGOUT_ACTION = '[Logout action] logout action';
export const NAVTOGGLE = 'NAVTOGGLE';

export function signupAction(email, password, navigate) {
	
    return (dispatch) => {
        signUp(email, password)
        .then((response) => {
            saveTokenInLocalStorage(response.data);
            runLogoutTimer(
                dispatch,
                response.data.expiresIn * 1000,
                //history,
            );
            dispatch(confirmedSignupAction(response.data));
            navigate('/dashboard');
			//history.push('/dashboard');
        })
        .catch((error) => {
            const errorMessage = formatError(error.response.data);
            dispatch(signupFailedAction(errorMessage));
        });
    };
}

export function Logout(navigate) {
	sessionStorage.removeItem('authUser');
    // Liste des routes à exclure de la redirection automatique vers /landing
  const excludedRoutes = ["/sendNewPassword-password", "/otp", "/page-forgot-password", "/Resetemail", "/login"];

  // Vérifie si le chemin actuel est dans la liste des routes exclues
  const currentPath = window.location.pathname;
  if (excludedRoutes.some((route) => currentPath.startsWith(route))) {
    console.log("Redirection vers la page actuelle car elle est exclue...");
    navigate(currentPath); // Redirige vers la même page (ne change rien)
  } else {
    console.log("Redirection vers /landing après déconnexion...");
    navigate("/landing"); // Redirige vers /landing par défaut
  }

	//history.push('/login');
    
	return {
        type: LOGOUT_ACTION,
    };
}

export function loginAction(email, password, navigate) {
    return (dispatch) => {
         login(email, password)
            .then((response) => { 
                console.log(response)
                 saveTokenInLocalStorage(response);
                runLogoutTimer(
                    dispatch,
                    response.expiresIn * 1000,
                    navigate,
                );
                dispatch(loginConfirmedAction(response));
			   //console.log('kk------1');
			   //console.log(kk);
			   //console.log(response.data);
			   //console.log('kk------2');
			   //return response.data;
				//return 'success';
				//history.push('/dashboard');                
				navigate('/dashboard');                
            })
          /*   .catch((error) => {
				//console.log('error');
				//console.log(error);
                const errorMessage = formatError(error.response);
                dispatch(loginFailedAction(errorMessage));
            }); */
    };
}

export function loginFailedAction(data) {
    return {
        type: LOGIN_FAILED_ACTION,
        payload: data,
    };
}

export function loginConfirmedAction(data) {
    return {
        type: LOGIN_CONFIRMED_ACTION,
        payload: data,
    };
}

export function confirmedSignupAction(payload) {
    return {
        type: SIGNUP_CONFIRMED_ACTION,
        payload,
    };
}

export function signupFailedAction(message) {
    return {
        type: SIGNUP_FAILED_ACTION,
        payload: message,
    };
}

export function loadingToggleAction(status) {
    return {
        type: LOADING_TOGGLE_ACTION,
        payload: status,
    };
}


export const navtoggle = () => {
    return {        
      type: 'NAVTOGGLE',
    };
};